import * as z from 'zod/v4';

import { apiErrorSchema } from '../error/entry.js';
import { retailerBalanceResponse } from './RetailerBalance.js';

export const retailerBalanceTransformSchema = retailerBalanceResponse.transform((result) => ({
  data: result,
}));

export const retailerBalanceApiResponse = {
  parse: (data: unknown) => z.union([retailerBalanceTransformSchema, apiErrorSchema]).parse(data),
} as const;
